export enum MONITORING_TABS {
  MEMBERS = "Members",
  INVITATIONS = "Invitations",
}
